import {BackButton} from "@varymadellc/my-weed-club-component-library";
import React from "react";
import Page from "@/layout/Page";

export default function Index() {
    return (
        <Page className="mx-4 mb-4 bg-gradient-to-bl" title="Radio" menu={<BackButton/>}>
            <div>
                <iframe src="https://embed.radio.co/player/0981caa.html" width="100%" height="500"/>
            </div>
        </Page>
    );
}